import Condition from "@viz-ui/models/conditionalFormatting/condition";
import ConditionalFormat from "@viz-ui/models/conditionalFormatting/conditionalFormat";

angular
  .module("acl.visualizer.model.conditionalFormatting", ["acl.visualizer.model.model"])
  .factory("Condition", () => Condition)
  .factory("ConditionalFormat", () => ConditionalFormat);
